import { CategoryTypeService } from "@/core/services/category-type.service";
import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, exhaustMap, map, of } from "rxjs";
import { CategoryTypeActions } from "./category-type.actions";
import { CategoryTypeApiModel } from "@/core/models/api/category-type-api-model.model";
@Injectable()
export class CategoryTypeEffects {
    actions$ = inject(Actions);
    categoryTypeService = inject(CategoryTypeService);

    constructor(){

    }

    _loadEmployee = createEffect(() => {
        return this.actions$.pipe(
            ofType(CategoryTypeActions.loadCategoryTypes),
            exhaustMap(() => {
                return this.categoryTypeService.getAll().pipe(
                    map((response: any) => {
                        const categoryTypes = response as CategoryTypeApiModel[];
                        return CategoryTypeActions.loadCategoryTypesSuccess({ categoryTypes});
                    }),
                    catchError((error) => {
                        console.error(error);
                        return of(CategoryTypeActions.loadCategoryTypesFail({ error: error.message }));
                    })
                )
            })
        )
    })

    _addCategoryType = createEffect(() => {
        return this.actions$.pipe(
            ofType(CategoryTypeActions.addCategoryType),
            exhaustMap((action) => {
                return this.categoryTypeService.add(action.categoryType).pipe(
                    map((response: any) => {
                        return CategoryTypeActions.loadCategoryTypes();
                    }),
                    catchError((error) => {
                        console.error(error);
                        return of();
                    })
                )
            })
        )
    })

    _updateCategoryType = createEffect(() => {
        return this.actions$.pipe(
            ofType(CategoryTypeActions.updateCategoryType),
            exhaustMap((action) => {
                return this.categoryTypeService.update(action.categoryType).pipe(
                    map((response: any) => {
                        // const categoryType = response as CategoryTypeApiModel;
                        // return CategoryTypeActions.updateCategoryTypeSuccess({ categoryType });
                        return CategoryTypeActions.loadCategoryTypes();
                    }),
                    catchError((error) => {
                        console.error(error);
                        return of();
                    })
                )
            })
        )
    })

    _deleteCategoryType = createEffect(() => {
        return this.actions$.pipe(
            ofType(CategoryTypeActions.deleteCategoryType),
            exhaustMap((action) => {
                return this.categoryTypeService.delete(action.categoryTypeId).pipe(
                    map((response: any) => {
                        return CategoryTypeActions.deleteCategoryType({ categoryTypeId: action.categoryTypeId });
                    }),
                    catchError((error) => {
                        console.error(error);
                        return of();
                    })
                )
            })
        )
    })
}